import React from 'react';
import { LoadingScreenDesktop } from './LoadingScreenDesktop';
import { LoadingScreenMobile } from './LoadingScreenMobile';

export const LoadingScreen = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <LoadingScreenMobile /> : <LoadingScreenDesktop />;
};